export default "__VITE_PUBLIC_ASSET__323ae7f7__"